export interface RatingCaseResponse {
  data: any[];
  msg: string;
}
